import { useState, useEffect } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { BottomTabBar } from '@/components/layout/BottomTabBar'
import { apiUrl } from '@/lib/api'

interface DashboardData {
  studentCount: number
  lineLinkedCount: number
  attendanceTodayCount: number
  kycPendingCount: number
}

export function DashboardPage() {
  const { teacher } = useAuth()
  const [data, setData] = useState<DashboardData | null>(null)

  useEffect(() => {
    fetch(apiUrl('/api/dashboard/summary'), { credentials: 'include' })
      .then((r) => r.json())
      .then((res) => {
        if (res.success) setData(res.data)
      })
      .catch(() => {})
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <header className="bg-white px-4 py-4 shadow-sm">
        <div className="mx-auto max-w-lg">
          <p className="text-sm text-gray-500">สวัสดี</p>
          <h1 className="text-lg font-bold text-gray-900">{teacher?.displayName || 'ครู'}</h1>
        </div>
      </header>

      {/* Metric Cards */}
      <main className="mx-auto max-w-lg px-4 py-4">
        <div className="grid grid-cols-2 gap-3">
          <MetricCard
            label="นักเรียนทั้งหมด"
            value={data ? String(data.studentCount) : '-'}
            color="blue"
          />
          <MetricCard
            label="เชื่อมต่อ LINE"
            value={data ? String(data.lineLinkedCount) : '-'}
            color="green"
          />
          <MetricCard
            label="เช็คชื่อวันนี้"
            value={data ? String(data.attendanceTodayCount) : '-'}
            color="purple"
          />
          <MetricCard
            label="รอตรวจ KYC"
            value={data ? String(data.kycPendingCount) : '-'}
            color="orange"
          />
        </div>
      </main>

      <BottomTabBar active="dashboard" />
    </div>
  )
}

function MetricCard({
  label,
  value,
  color,
}: {
  label: string
  value: string
  color: 'blue' | 'green' | 'purple' | 'orange'
}) {
  const colors = {
    blue: 'bg-blue-50 text-blue-700',
    green: 'bg-green-50 text-green-700',
    purple: 'bg-purple-50 text-purple-700',
    orange: 'bg-orange-50 text-orange-700',
  }

  return (
    <div className="rounded-lg bg-white p-4 shadow-sm">
      <p className="text-xs text-gray-500">{label}</p>
      <p className={`mt-1 text-2xl font-bold ${colors[color]}`}>{value}</p>
    </div>
  )
}
